import React from "react";
import { Col, Row } from "react-bootstrap";
function ViewButtonContainer({ children }) {
    return (
        <div className="w-100">
            <Row
                style={{
                    margin: "0 !important",
                    gap: "0px",
                    marginRight: "5px",
                    marginLeft: "5px",
                }}
                className="d-flex justify-content-center"
            >
                {children.map((viewButton, idx) => {
                    return (
                        <Col key={`vbtn-${idx}`} style={{ maxWidth: "65px" }}>
                            {viewButton}
                        </Col>
                    );
                })}
            </Row>
        </div>
    );
}

export default ViewButtonContainer;
